import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaArrowCircleLeft, FaArrowLeft, FaPlus } from 'react-icons/fa';
import { useDropzone } from 'react-dropzone';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from 'react-router-dom';

import {
  getCalibracionesCliente,
  clearErrors,
  deleteCalibracion,
  subirReporteCalibracionTabla,
  deleteDataCalibracionTabla
} from '../../../redux/actions/dataactions';

const FileDropzone = ({ onFileDrop }) => {
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    maxFiles: 1,
    onDrop: onFileDrop
  });

  return (
    <div className="dropzone-container mt-4">
      <div {...getRootProps({ className: 'dropzone' })} style={{
        border: '2px dashed #90A4AE',
        borderRadius: 10,
        padding: 18,
        textAlign: 'center',
        cursor: 'pointer'
      }}>
        <input {...getInputProps()} />
        <p className="dropzone-text" style={{ margin: 0 }}>
          Arrastra y suelta el archivo aquí, o haz clic para seleccionarlo
        </p>
        <em className="dropzone-info" style={{ fontSize: 12 }}>
          (Solo se permite subir un archivo PDF, DOC o DOCX)
        </em>
      </div>

      <aside className="dropzone-preview" style={{ marginTop: 12 }}>
        {fileRejections.length > 0 && (
          <div className="file-error" style={{ color: '#D32F2F' }}>
            <h4 style={{ margin: 0, fontSize: 14 }}>Solo se puede cargar un archivo</h4>
          </div>
        )}

        {acceptedFiles.length > 0 && (
          <div className="file-accepted">
            <h4 style={{ margin: '6px 0', fontSize: 14 }}>Archivo a cargar:</h4>
            <ul className="file-list" style={{ margin: 0, paddingLeft: 18 }}>
              {acceptedFiles.map(file => (
                <li key={file.path} className="file-item">
                  {file.path} - {file.size} bytes
                </li>
              ))}
            </ul>
          </div>
        )}
      </aside>
    </div>
  );
};

export class SubirReportesCal extends Component {
     constructor(){
          super();
          this.state={
            selectedFile: null,
            progid:'',
            openatach: false,
            open:false,
            opendelete:false,
            fecha:'',
            horainicio:'',
            horafinal:'',
            numcertificado:'',
            reporteurl:'',
            reportefilename:'',
            calibracionid:'',
            equipoid:''
          }
        }

    componentDidMount(){
        this.props.getCalibracionesCliente(this.props.match.params.clienteId);
       }

       //******borrar Reporte de Calibración */
handleOpenDelete=(rawdata)=>{
    this.setState({opendelete:true,
       reportefilename:rawdata.reportefilename,
      calibracionid:rawdata.calibracionid,  
      equipoid:rawdata.equipoid
    });
   
    };
  
  
  handleCloseDelete=()=>{
    // this.props.clearErrors();
     this.setState({opendelete:false});
     };
  
  
  handleDelete=()=>{
  

  this.props.deleteDataCalibracionTabla(this.state.calibracionid,this.props.match.params.clienteId);
  
  this.handleCloseDelete();
  
  }

 handleDrop = (acceptedFiles) => {
    // acceptedFiles es un array; tomamos el primero
    const file = Array.isArray(acceptedFiles) ? acceptedFiles[0] : acceptedFiles;
    this.setState({ selectedFile: file || null });
  };

  onFileUpload = () => {
    if (!this.state.selectedFile) return;
    const formData = new FormData();
    formData.append("myFile", this.state.selectedFile, this.state.selectedFile.name);

    console.log("equipoid "+this.state.equipoid);
    console.log("clienteid "+this.props.match.params.clienteId);
    this.props.subirReporteCalibracionTabla(
      formData,
      this.state.equipoid,
      this.props.match.params.clienteId,
      this.state.progid
    );
    this.setState({ openatach:false, selectedFile: null });
  };
  
//Subir Reporte ATACH
handleOpenAtach=(rawdataprogid,rawdataequipoid)=>{
    this.setState({openatach:true,progid:rawdataprogid,equipoid:rawdataequipoid});
  
};
handleCloseAtach=()=>{
   this.setState({openatach:false});
};
onFileChange = event => { 
  // Update the state 
  this.setState({ selectedFile: event.target.files[0] }); 
 
}; 


handleOpen=(rawdata)=>{
    this.mapUserDetailsToState(rawdata);
    this.setState({open:true})
  }
  handleClose=()=>{
    this.setState({open:false});
  };
  
  mapUserDetailsToState = (calibracion) => {
    this.setState({
      fecha:calibracion.fecha?calibracion.fecha:'',
      horainicio:calibracion.horainicio?calibracion.horainicio:'',
      horafinal:calibracion.horafinal?calibracion.horafinal:'',
      numcertificado:calibracion.numcertificado?calibracion.numcertificado:'',
      reporteurl:calibracion.reporteurl?calibracion.reporteurl:'',
      
      
    });
  };
  
  
     
 
  handleGoBack = () => {
    this.props.history.goBack(); // Utiliza la función goBack del historial del navegador
}

  render() {
    const { calibraciones, loadingcal } = this.props.data;

    const rows = calibraciones
      ? calibraciones.map((cal) => ({ id: cal.calibracionid, ...cal }))
      : [];

    const columns = [
      {
        field: 'actions',
        headerName: 'Acciones',
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Box>
            <Tooltip title="Reporte de Calibración">
              <IconButton
                size="small"
                onClick={() => this.handleOpen(params.row)}
              >
                <AssignmentIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Adjuntar Certificado PDF">
              <IconButton
                size="small"
                onClick={() =>
                  this.handleOpenAtach(
                    params.row.calibracionid,
                    params.row.equipoid
                  )
                }
              >
                <AttachFileIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Borrar Calibración">
              <IconButton
                size="small"
                onClick={() => this.handleOpenDelete(params.row)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
      { field: 'idinventario', headerName: 'ID', width: 120 },
      { field: 'nombre', headerName: 'Equipo', width: 150 },
      { field: 'ubicacion', headerName: 'Ubicación', width: 150 },
      { field: 'servicio', headerName: 'Servicio', width: 150 },
      { field: 'fecha', headerName: 'Fecha', width: 150 },
      { field: 'numcertificado', headerName: 'No. Certificado', width: 150 },
      {
        field: 'reporteurl',
        headerName: 'Link Certificado',
        width: 160,
        renderCell: (params) =>
          params.value === 'false' ? (
            <Typography variant="body2">Sin Certificado Adjunto</Typography>
          ) : (
            <a
              href={params.value}
              target="_blank"
              rel="noopener noreferrer"
            >
              Link del Certificado
            </a>
          )
      }
    ];

    const dataGrid = !loadingcal ? (
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        components={{
          Toolbar: () => (
            <Box p={1}>
              <GridToolbarQuickFilter placeholder="Buscar..." />
            </Box>
          )
        }}
        sx={{
          height: 500,
          width: '100%',
          mt: 2,
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: 'primary.main',
            color: 'white'
          }
        }}
      />
    ) : (
      <Box
        sx={{
          height: 500,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <CircularProgress size={50} color="primary" />
      </Box>
    );

    const linkcalibracion =
      this.state.reporteurl === 'false' ? (
        <Typography>Sin Certificado Adjunto</Typography>
      ) : (
        <a
          href={this.state.reporteurl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Link del Certificado
        </a>
      );

    return (
      <div>
        <div className="titulo_section">
          <div className="titulo_clientes">
            <h1 className="text-clientes">Subir Reportes de Calibración</h1>
            <hr className="clientes_separator" />
          </div>

          <div className="div_boton">
            <Link
              to={`/dashboard/perfilcliente/${this.props.match.params.clienteId}/cronocalperfil`}
            >
              <Tooltip title="Volver">
                <IconButton size="small">
                  <FaArrowCircleLeft color="#03178C" size={20} />
                </IconButton>
              </Tooltip>
            </Link>
          </div>
        </div>

        <div className="div-tabla-equipos">{dataGrid}</div>

        <Dialog
          open={this.state.opendelete}
          onClose={this.handleCloseDelete}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <Typography
              sx={{
                fontSize: '20px',
                fontWeight: 600,
                color: '#0468BF',
                textAlign: 'center'
              }}
            >
              Estas seguro de borrar esta Calibración?
            </Typography>
          </DialogTitle>
          <DialogActions sx={{ justifyContent: 'flex-end' }}>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleCloseDelete}>
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Borrar Calibración">
              <IconButton onClick={this.handleDelete}>
                <FaPlus color="#03178C" />
              </IconButton>
            </Tooltip>
          </DialogActions>
        </Dialog>

        <Dialog
  open={this.state.openatach}
  onClose={this.handleCloseAtach}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>
    <Typography
      sx={{ fontSize:'20px', fontWeight:600, color:'#0468BF', textAlign:'center' }}
    >
      Subir Certificado de Calibración
    </Typography>
  </DialogTitle>

  <DialogContent>
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid item xs={12}>
        {/* ⬇️ Aquí usamos el FileDropzone */}
        <FileDropzone onFileDrop={this.handleDrop} />
      </Grid>

      
    </Grid>
  </DialogContent>

  <DialogActions sx={{ justifyContent: 'flex-end' }}>
    <Tooltip title="Cerrar">
      <IconButton onClick={this.handleCloseAtach}>
        <FaArrowLeft color="#D3D7DC" />
      </IconButton>
    </Tooltip>
    <Tooltip title={this.state.selectedFile ? "Subir Certificado" : "Selecciona un archivo"}>
      <span>
        <IconButton
          onClick={this.onFileUpload}
          disabled={!this.state.selectedFile}
        >
          <FaPlus color={this.state.selectedFile ? "#03178C" : "#B0BEC5"} />
        </IconButton>
      </span>
    </Tooltip>
  </DialogActions>
</Dialog>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <Typography
              sx={{
                fontSize: '20px',
                fontWeight: 600,
                color: '#0468BF',
                textAlign: 'center'
              }}
            >
              Reporte de Calibración
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} mt={2}>
                <TextField
                  required
                  type="date"
                  name="fecha"
                  label="Fecha de Realización"
                  value={this.state.fecha}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  type="time"
                  name="horainicio"
                  label="Hora de Inicio"
                  value={this.state.horainicio}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  type="time"
                  name="horafinal"
                  label="Hora Final"
                  value={this.state.horafinal}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  type="text"
                  name="numcertificado"
                  label="Numero del Certificado"
                  value={this.state.numcertificado}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12}>{linkcalibracion}</Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'flex-end' }}>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose}>
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

SubirReportesCal.propTypes = {
  getCalibracionesCliente: PropTypes.func.isRequired,
  subirReporteCalibracionTabla: PropTypes.func.isRequired,
  deleteCalibracion: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  deleteDataCalibracionTabla: PropTypes.func.isRequired
};


const mapActionsToProps={getCalibracionesCliente,clearErrors,deleteCalibracion,deleteDataCalibracionTabla,subirReporteCalibracionTabla};

const mapStateToProps = (state)=>({
    data:state.data,
    UI:state.UI
})



export default connect(mapStateToProps,mapActionsToProps)(SubirReportesCal);